import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { POSITION_ENUM } from 'Common/Constants/Enumeration/PopUpPositionEnum';

export const ToolTipComponent = props => {
  const { label, popMessage, iconName, position } = props;
  return (
    <span>
      {label}
      <Popup
        position={position}
        content={popMessage}
        trigger={<Icon name={iconName} />}
      />
    </span>
  );
};

ToolTipComponent.defaultProps = {
  position: POSITION_ENUM.TopCenter,
};

ToolTipComponent.propTypes = {
  label: PropTypes.string.isRequired,
  popMessage: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  position: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/toolTipComponent/ToolTipComponent.js